import {EnvConfig} from '../../../config/envConfig.interface';
import {AuthService} from '../../../services/authService';
import {ITrackingService} from '../../../services/gtmHelper';
import {IUserService} from '../../../services/user';
import {ILoginFlow} from './loginFlow';
import {RedirectLoginFlow} from './redirectLoginFlow';

export interface ILoginFlowFactory {
  getLoginFlow(): ILoginFlow;
}

export class LoginFlowFactory implements ILoginFlowFactory {
  constructor(
    protected configuration: EnvConfig,
    protected authService: AuthService,
    protected userService: IUserService,
    protected trackingService: ITrackingService,
  ) {}
  getLoginFlow(): ILoginFlow {
    return new RedirectLoginFlow(
      this.configuration,
      this.authService,
      this.trackingService,
    );
  }
}
